<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        
      </div>
      <div class="bigdata">
        <div class="hadoop">
          <ul>
            <li class="icon_a"><a href="#/hadoop/beanstalk">Beanstalk企业研发管理平台</a></li>
            <li class="icon_b actived"><a href="#/hadoop/bigdataPlatform">大数据测试平台</a></li>
            <li class="icon_c"><a href="#/hadoop/agileManagement">敏捷管理咨询</a></li>
            <li class="icon_d"><a href="#/hadoop/qualityManagement">质量管理咨询</a></li>
          </ul>
        </div>
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>大数据测试平台</h2></div>
          <span></span>
        </div>
        <div class="view-tip">
          <p class="title">大数据测试面临的挑战</p>
           <div class="detail">
            <span>管理层面临的挑战</span>
            <ul>
              <li>质量伴随业务复杂度和数量增加，质量成反比下降（质量下降10%）；</li>
              <li>成本伴随提高质量不断追加（成本增加8%）。</li>
            </ul>
           </div>
           <div class="detail">
            <span>测试员工面临的挑战</span>
            <ul>
              <li>测试数据复杂：测试数据的生成难度大、步骤繁琐，数据量大。</li>
              <li>人员要求高：数据来源繁杂，层次多，数据关系梳理困难。测试结果需要人工对比，效率极低。</li>
              <li>问题排查复杂：由于业务错中复杂，问题报错基本两类。1类数据不准2无法出数。在排查这两个问题需要从数据接口、作业、表关系、开发业务逻辑等维多从分析，排查问题大大高
                  于常规业务系统。</li>
              <li>缺少工具：由于数据测试是一个业务垂直领域的细分，目前市面上没有针对性极强的测试工具来支持。</li>
            </ul>
           </div>
        </div>
        <div class="view-tip">
          <p class="title">痛点分析</p>
          <div class="detail">
            <p style="margin-top:-10px;margin-bottom:5px">大数据测试中的痛点——测试数据准备</p>
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata1.png" alt="">
            </div>
          </div>
          <div class="detail">
            <p style="margin-top:50px;margin-bottom:5px">大数据测试中的痛点——问题排查</p>
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata2.png" alt="">
            </div>
          </div>
          <div class="detail">
            <p style="margin-top:50px;margin-bottom:5px">大数据测试中的痛点——接口不一致</p>
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata3.png" alt="">
            </div>
          </div>
        </div>
        <div class="view-tip">
          <p class="title">功存大数据测试平台功能</p>
          <div class="detail">
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata4.png" alt="">
            </div>
          </div>
        </div>
        <div class="view-tip">
          <p class="title">优势</p>
          <div class="detail">
            <span>模型逐层单例测试法</span>
            <p>将目标表与其中一个源表关联,根据业务判断关联出来的结果是否与另一表一致；如果出现表与表的关联需要特别关注关联条件的正确，确保该关联的条件符合所有业务条件等。到达
                数据指标标准。</p>
            <span>模型层次整合测试法</span>
            <p>模拟ETL各阶段数据处理过程，分阶段比对数据结果，如：贴源层与上游数据文件比对，标准化层与贴源层数据比对、标准化层与主题层比对、主题层与共性层比对及卸数文件与下游
                接口比对等；验证模型是否符合设计标准。</p>
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata5.png" alt="">
            </div>
          </div>
        </div>
        <div class="view-tip">
          <p class="title">价值</p>
          <div class="detail">
            <p>通过功存大数据测试工具的赋能，客户在4个基本指标上都有显著的提高。有效的提高了测试效率，提升了测试质量，降低了测试人员的技能，从而降低了成本的逐年追加。</p>
            <div style="margin-top:32px;">
              <img style="width:1200px" src="../../../public/hadoopImg/bigdata6.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';
export default {
  components: { navmenu,footerMenu },
  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'大数据及效能',
          detail:'Big data & efficiency',
          src: require("../../../public/hadoopImg/dashuju1.png"),
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

.view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 40px;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: disc;
        margin-left: 18px;
        li{
          padding-bottom: 5px;
        }
      }
    }
  }


.bigdata{
  height: 3701px;
  position: relative;
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-75px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;line-height: 40px;}
      .icon_a{
        background: url("../../../public/hadoopImg/icon_a.png") no-repeat;
      }
      .icon_a:hover{
        background: url("../../../public/hadoopImg/icon_a1.png") no-repeat;
      }
      .icon_b{
        background: url("../../../public/hadoopImg/icon_b.png") no-repeat;
      }
      .actived,.icon_b:hover{
        background: url("../../../public/hadoopImg/icon_b1.png") no-repeat;
      }
      .actived a{color: #01619E;}
      .icon_c{
        background: url("../../../public/hadoopImg/icon_c.png") no-repeat;
      }
      .icon_c:hover{
        background: url("../../../public/hadoopImg/icon_c1.png") no-repeat;
      }
      .icon_d{
        background: url("../../../public/hadoopImg/icon_d.png") no-repeat;
      }
      .icon_d:hover{
        background: url("../../../public/hadoopImg/icon_d1.png") no-repeat;
      }
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Hadoop/bigdataPlatform.vue